import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { RenderInput } from './Base';
import { Viewer } from "../../../widgets/Viewer";

import LoadingButton from '../../../widgets/LoadingButton';
import { Dialog } from '@blueprintjs/core';

import { saveThankYouNote } from '../../../../redux/actions/thankYouNote.actions';

const mapStateToProps = (state, ownProps) => ({
    thankYouNote: state.thankYouNote
});

class AddThankYouNote extends Component {
    constructor(props) {
        super(props);
        this.emptyForm = {
            note_recipient: '',
            date_written: new Date(),
            favourite_subject: '',
            likes_dislikes: '',
            hobbies_interests: '',
            career_goals: '',
            message: '',
            dropbox_image_share_url: '',
            filename: '',
            image: ''

        };
        this.state = {
            showModal: false,
            form: this.emptyForm
        };
    }
    componentDidMount() {
        window.addEventListener('open-thank-you-note-modal', this.openModal);
    }
    componentWillUnmount() {
        window.removeEventListener('open-thank-you-note-modal', this.openModal);
    }
    componentWillReceiveProps(nextProps) {
        const { thankYouNote: { saveSuccess }} = nextProps;
        if (saveSuccess) {
            this.closeModal();
        }
    }
    openModal = event => {
        const { detail } = event;
        const form = detail.id ? { ...detail } : { ...detail, ...this.emptyForm };
        this.setState({ showModal: true, form });
    }
    closeModal = () => {
        this.setState({ showModal: false });
    }
    onChangeHandler = ({ text, file, value }) => {
        const { form } = this.state;

        // Extract last file
        if (file && file[0]) {
            const reader = new FileReader();
            const lastFile = file[0];
            reader.readAsDataURL(lastFile);
            reader.onloadend = () => {
                form.image = reader.result;
                this.setState({ form });
            }
            form.filename = lastFile.name;
        }
        if (text !== undefined) {
            form[value] = text;
        }
        this.setState({ form });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.saveThankYouNote();
        }
    }
    saveThankYouNote = () => {
        const newForm = { ...this.state.form }
        if (newForm.image) {
            newForm.image = newForm.image.split(',')[1];
        }
        this.props.saveThankYouNote(newForm);
    }
    render() {
        const { showModal, form } = this.state;
        const { saveLoading } = this.props.thankYouNote;

        return (
            <Dialog icon='envelope'
                style={{ width: '1000px'}}
                isOpen={showModal}
                onClose={() => this.closeModal()}
                canOutsideClickClose={false}
                title="Add Thank You Note">
                { showModal ?
                    <Fragment>
                        <div className="pt-dialog-body">
                            <div className="flex-row">
                                <RenderInput label="Date Written"
                                    name="date_written"
                                    value={form.date_written}
                                    datePicker
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Favorite Subject"
                                    name="favourite_subject"
                                    value={form.favourite_subject}
                                    onChangeHandler={this.onChangeHandler} />
                                <RenderInput label="Hobbies & Interests"
                                    name="hobbies_interests"
                                    value={form.hobbies_interests}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Likes and Dislikes"
                                    name="likes_dislikes"
                                    value={form.likes_dislikes}
                                    type="textarea"
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Career Goals"
                                    name="career_goals"
                                    value={form.career_goals}
                                    type="textarea"
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput label="Message"
                                    name="message"
                                    value={form.message}
                                    type="textarea"
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                <RenderInput name="filename"
                                    type="upload"
                                    value={form.filename}
                                    onChangeHandler={this.onChangeHandler} />
                            </div>
                            <div className="flex-row">
                                { form.image || form.dropbox_image_share_url ?
                                     <div className="flex-column">
                                        <Viewer src={form.image || form.dropbox_image_share_url || ''} style={{ width: '100%' }} />
                                    </div> : null
                                }
                            </div>
                        </div>
                        <div className="pt-dialog-footer">
                            <div className="pt-dialog-footer-actions">
                                <LoadingButton className="pt-button pt-fill pt-intent-primary pt-large" text="Save Thank You Note" onClick={this.saveThankYouNote} isLoading={saveLoading} />
                            </div>
                        </div>
                    </Fragment> : null
                }
            </Dialog>
        );
    }
}

export default connect(
    mapStateToProps,
    { saveThankYouNote }
)(AddThankYouNote);



// WEBPACK FOOTER //
// ./src/components/main/dashboard/modals/ThankYouNoteModal.jsx